"use client";
import Stack from "@mui/material/Stack";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import Button from "@/components/common/Button";
import { useCustomFormContext } from "@/components/site-builder/modules/CustomFormModule/context/customFormContext";
import { useCustomFormDefaultValues } from "@/components/site-builder/modules/CustomFormModule/hooks/useCustomFormDefaultValues";
import { ButtonColor, ButtonSize, ButtonVariant } from "@/constants/button";
import { useTranslation } from "@/i18n/client";

export interface FormControlButtonsProps {
  submitDisabled?: boolean;
  resetFormSubmission: () => void;
}

export default function FormControlButtons(props: FormControlButtonsProps) {
  const { submitDisabled, resetFormSubmission } = props;

  const {
    formEntity: {
      data: { showResetButton, submitButtonText, submitResetText },
    },
    formEntity,
    isSubmitting,
  } = useCustomFormContext();

  const { t } = useTranslation("form-elements");
  const defaultValues = useCustomFormDefaultValues({ formEntity });
  const { reset } = useFormContext();

  const handleResetButtonClick = useCallback(() => {
    resetFormSubmission();
    reset(defaultValues);
  }, [defaultValues, reset, resetFormSubmission]);

  return (
    <Stack direction="row" justifyContent="flex-end" spacing={2}>
      {showResetButton && (
        <Button
          type="button"
          size={ButtonSize.Small}
          color={ButtonColor.Primary}
          variant={ButtonVariant.Outlined}
          onClick={handleResetButtonClick}
          disabled={isSubmitting}
        >
          {submitResetText || t("button.reset.label")}
        </Button>
      )}
      <Button
        type="submit"
        size={ButtonSize.Small}
        color={ButtonColor.Primary}
        variant={ButtonVariant.Contained}
        disabled={submitDisabled || isSubmitting}
      >
        {submitButtonText || t("button.submit.label")}
      </Button>
    </Stack>
  );
}
